/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'

import './Forget.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import Logo from '../../assets/svg/logo.svg'
import { put } from '../../services/https'

import loadingPic from '../../assets/svg/Loading.svg'

import { useNavigate } from 'react-router-dom'

export default function index() {
  const [password, setPassword] = useState('')
  const [rePassword, setRePassword] = useState('')
  const [alertPassword, setAlertPassword] = useState(false)
  const [alertRePassword, setReAlertPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const passwordHandler = (e) => {
    e.preventDefault( )
    if (password.length >= 6) {
      setAlertPassword(false)
    } else {
      setAlertPassword(true)
    }

    if (rePassword.length >= 6) {
      setReAlertPassword(false)
    } else {
      setReAlertPassword(true)
    }

    if (password === rePassword) {
      setReAlertPassword(false)
    } else {
      setReAlertPassword(true)
    }

    if (password.length >= 6 && rePassword.length >= 6 && password === rePassword) {
      setLoading(true)
      put('/api/front/users/changepassword', {
        phoneNumber: localStorage.getItem('phoneNumber'),
        password: rePassword
        }).then(response => {
          if (response.data.messageFa === "با موفقیت آپدیت شد") {
            navigate('/login')
          }
        }).catch(error => {
          setLoading(false)
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
    }
  }

  return (
    <div id='login'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className='scroll'>
        <img src={Logo} alt='Logo' />
        <span className='title'>کانولی</span>
        <span className='subtitle'>خوش آمدید</span>
        <form action=''>
          <div className='input'>
            <label htmlFor=''>پسوورد جدید :</label>
            <input onChange={e => setPassword(e.target.value)} type='password' name='' id='' placeholder='پسوورد جدید' />
            <small style={alertPassword ? {} : { display: 'none' }}>پسوورد صحیح نیست</small>
          </div>
          <div className='input'>
            <label htmlFor=''>تکرار پسوورد :</label>
            <input onChange={e => setRePassword(e.target.value)} type='password' name='' id='' placeholder='تکرار پسوورد' />
            <small style={alertRePassword ? {} : { display: 'none' }}>تکرار پسوورد صحیح نیست</small>
          </div>
          <div className='button'>
            <span>
            </span>
            <span>
              <button onClick={passwordHandler}>
                <span style={loading ? {display: 'none'} : {}}>ثبت</span>
                <img style={loading ? {} : {display: 'none'}} className='loadingPic' src={loadingPic} alt='loadingPic' />
              </button>
            </span>
          </div>
        </form>
      </div>
      <Footer page={''} />
    </div>
  )
}
